export default __webpack_public_path__ + "line.ac8790.svg";